import { computed } from 'vue';
import { getOffsetDiff } from '@/ui/helpers';
import { user } from '@/ui/auth/auth';
import { utcToZonedTime } from 'date-fns-tz';

export const useTimeZonedDates = () => {
  const offsetDiff = computed(() => getOffsetDiff(user.value.timezone));

  const getDateInUserTimeZone = (date: Date) => {
    if (offsetDiff.value === 0) {
      return date;
    }

    return utcToZonedTime(date, user.value.timezone);
  };

  const getDateInLocalTimeZone = (date: Date) => {
    const newDate = new Date(date);

    if (offsetDiff.value !== 0) {
      newDate.setMinutes(date.getMinutes() + offsetDiff.value);
    }

    return newDate;
  };

  return {
    offsetDiff,
    getDateInUserTimeZone,
    getDateInLocalTimeZone,
  };
};
